const theme = {
  main: "#EB1700",
  black: "#000000",
  white: "#ffffff",
  lightGrey: "#F0EFED",
  footer: "#312C2A",
  lightBorder: "#BCBCBC",
  backgroundGrey: "#F8F8F8",
  blue: "#1E3C76",
  green: "#00B463",
  greenHover: "#7CD6AE",
  link: "#00b4e1",
  preOp: "#312C2A",
  postOp: "#548925",
  cardBorder: "#D3CFC9",
  disabled: "#00000080",
  lightBlue: "rgba(30, 60, 118, 0.1)",
  grey: "#DCDCDC",
  darkGrey: "#747474",
  purple: "#675DC5",
  incision: "#1478B4",
  responseBorder: "#978F88",
  hyperlink: "#0000ff",
  sms: "#009343",
  off: "#C9C9C9",
  invalidPhone: "#FFB7AF",
  warning: "#E8A400",

  // buttons
  primary: {
    hovered: "#FF8275",
  },
  secondary: {
    hovered: "rgba(235, 23, 0, 0.1)",
  },
  toggleInactive: "#BFBCB4",

  // table
  table: {
    background: "#F9F8F7",
    dataBorder: "rgba(235, 23, 0, 0.25)",
    dob: "#BCBCBC",
  },

  // pill
  pill: {
    primary: {
      bg: "#69D0FF",
      text: "#1E3C76",
    },
    secondary: {
      bg: "#E6E6E6",
      text: "#000000",
    },
  },

  // broadcast asset type pills
  assetPill: {
    markdown: { bg: "#FFD3CF", text: "#EB1700" },
    video: { bg: "#B3C1DD", text: "#1E3C76" },
    pdf: { bg: "#EEFCE2", text: "#548925" },
    image: { bg: "#EACEFF", text: "#7A38AD" },
    document: { bg: "#D2D2D2", text: "#3C3C3C" },
    other: { bg: "#F3F3F3", text: "#000000" },
  },
};

export default theme;
